var polyfill = require('./dist/polyfill').default;

polyfill(require('./dist').default);